module.exports = __webpack_public_path__ + "media/images/flags/th-a65cc9bc0b9ffc4ee9c6df2795c5ba06.svg";